import React from 'react';
import './Footer.css';
import { FaFacebookF, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer className="site-footer">
      {/* ==== Main Footer Content ==== */}
      <div className="footer-content">

        {/* Company Description */}
        <div className="footer-company">
          <h3>Sapiencia.AI</h3>
          <p>
           The R&D company leveraging and innovating <br />
          AI technologies for Defense, Healthcare, <br />
          and Cybersecurity. 
          </p>
            <img
          src="/logo_motion.gif"
          alt="Sapiencia AI Logo"
          className="footer-logo-gif"
        />
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>Solutions</h4>
          <ul>
            <li>
              <Link to="/healthcare-ai">Healthcare AI</Link>
            </li>
            <li>
              <Link to="/salus-iam">Salus Tactical IAM and IGA</Link>
            </li>
            <li>
              <Link to="/cybersecurity">Cybersecurity &amp; AI Security</Link>
            </li>
            <li>
              <Link to="/sapienshield">SapienShield Firewall</Link>
            </li>
          </ul>
        </div>


        {/* Contact Info */}
        <div className="footer-contact">
          <h4>Contact</h4>
          <p><strong>Email:</strong></p>
          <p>operations@sapiencia.ai</p>

          <p><strong>Phone:</strong> +1 (223) 225-0608</p>

          <p><strong>Address:</strong><br />
            1200 Market Street, Unit 17, PMB # 108,<br />
            Lemoyne, Pennsylvania 17043, United States
          </p>

          {/* ==== Social Media Icons ==== */}
          <div className="social-media-icon-container">
            <a href="https://www.facebook.com/sapiencia.artificial.intelligence" 
            aria-label="Facebook">
              <FaFacebookF className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/company/sapiencia-ai/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedin className="social-icon" />
            </a>
            {/* Future social links (optional) */}
            {/* <a href="#"><FaInstagram className="social-icon" /></a> */}
            {/* <a href="#"><FaTwitter className="social-icon" /></a> */}
          </div>
        </div>

      </div>

      {/* ==== Footer Bottom Section ==== */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Sapiencia.AI. All rights reserved.</p>
        <p><a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
      </div>
    </footer>
  );
};

export default Footer;